import { getText, interpolate } from "shared/lib";

import { useCouncilLocalisation } from "shared/hooks";
import { useAccount } from "@/hooks";

export function PreSentToCouncilHelpMessage() {
  const { conversation } = useAccount();
  const { getLocalisationEntry } = useCouncilLocalisation(conversation);

  return (
    <div className="text-bodylg text-textPrimary flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h3 className="text-headingmd">
          {getText("Have a question about planning?")}
        </h3>
        <p>
          {interpolate(
            "If you would like to discuss a planning enquiry or your proposal with a planner, please {{contactCouncilLink}}. You may also find an answer to your question in the {{planningWebsiteLink}} of the council’s website.",
            {
              contactCouncilLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href={getLocalisationEntry("councilContactLink")}
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("contact Council")}
                </a>
              ),
              planningWebsiteLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href={getLocalisationEntry("councilPlanningWebsite")}
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("planning section")}
                </a>
              ),
            },
          )}
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="text-headingmd">
          {getText("Is there an issue, or do you have feedback?")}
        </h3>
        <p>
          {interpolate(
            "In partnership with your council, this service is managed by {{myLotLink}}, an Australian technology company.",
            {
              myLotLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href="https://mylot.ai"
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("myLot")}
                </a>
              ),
            },
          )}
        </p>
        <p>
          {interpolate(
            "If you’re experiencing an issue with the service or if you would like to provide feedback, please email {{helpEmailLink}}. We’ll get back to you as soon as we can.",
            {
              helpEmailLink: (
                <a
                  className="text-textLink hover:text-textLinkHover underline"
                  href="mailto:help@mylot.ai"
                >
                  help@mylot.ai
                </a>
              ),
            },
          )}
        </p>
      </div>
    </div>
  );
}
